import moment from "moment";
import { proposalStatusMap } from "services/proposal.service";
import AllocationHourRevereseWrapper from "./common/allocationHourReverseWrapper";
import { auditSA } from "./constants";


const derivedTableActions = (isProposed, isSoftblocked, isSuggested, suggestionStatus, roles, proposalStatus, setActiveResource, setShowDialog, session, setProposalDefaultValues, setSuggestionDefaultValue) => {
    const isAdminOrRM = ['admin', 'resource_manager', 'guest_rm', 'resource_manager_lead'].some((role) => session.data.user.role.includes(role));
    const isAdmin = ['admin'].some((role) => session.data.user.role.includes(role));
    const isPartner = session.data.user.gradeLevel === 'partner' && !isAdminOrRM;
    const isResource = session.data.user.gradeLevel === 'resource' && !isAdminOrRM;
    const isManager = session.data.user.gradeLevel === 'manager' && !isAdminOrRM;
    if ((isResource)) return [];
    if (proposalStatus === 'pending' && isManager) {
        return [
            {
                isDisabled: false,
                label: 'Reject',
                value: 'reject`',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('reject');
                }
            },
            {
                isDisabled: false,
                label: 'Approve',
                value: 'approve`',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('approve');
                }
            }];
    }
    if (isSoftblocked) {
        return isAdminOrRM ? [
            {
                isDisabled: false,
                label: 'Un-block',
                value: 'un-block`',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('un-block');
                }
            },
            {
                isDisabled: false,
                label: 'Extend',
                value: 'extend`',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('extend');
                }
            }
        ] : [];
    }
    if (isAdminOrRM && isSuggested) {
        return [
            ...(suggestionStatus === 'pending' ? [{
                isDisabled: false,
                label: 'Interested',
                value: 'interested',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('approveSuggestion');
                }
            },
            {
                isDisabled: false,
                label: 'Not interested',
                value: 'notInterested',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('notInterested');
                }
            }] : []),
            {
                isDisabled: false,
                label: 'Withdraw',
                value: 'Withdraw',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('withdrawSuggestion');
                }
            },
            {
                isDisabled: false,
                label: 'Soft-block',
                value: 'softblock`',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('soft-block');
                }
            },
            (suggestionStatus === 'pending' && {
                isDisabled: false,
                label: 'Update suggestion',
                value: 'suggestion`',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setSuggestionDefaultValue({
                        id: row?.id,
                        resourceId: row?.resourceId,
                        startDate: row?.startDate,
                        endDate: row?.endDate,
                        hoursPerWeek: row?.weeklyHours,
                        functionCode: row?.demand?.functionCode
                    });
                    setShowDialog('update-suggestion');
                }
            })
        ];
    }

    if (isSuggested && suggestionStatus !== 'rejected' && suggestionStatus !== 'approved') {
        return [
            {
                isDisabled: false,
                label: 'Interested',
                value: 'interested',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('approveSuggestion');
                }
            },
            {
                isDisabled: false,
                label: 'Not interested',
                value: 'notInterested',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('notInterested');
                }
            },
            {
                isDisabled: false,
                label: 'Withdraw',
                value: 'Withdraw',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('withdrawSuggestion');
                }
            }
        ];
    }
    return [
        ...(proposalStatus === 'pending'
            ? [
                {
                    isDisabled: false,
                    label: 'Reject',
                    value: 'reject`',
                    onSelectedItem: (_, row) => {
                        setActiveResource(row);
                        setShowDialog('reject');
                    }
                },
                {
                    isDisabled: false,
                    label: 'Approve',
                    value: 'approve`',
                    onSelectedItem: (_, row) => {
                        setActiveResource(row);
                        setShowDialog('approve');
                    }
                }] : []),
        {
            isDisabled: false,
            label: 'Withdraw',
            value: 'withdraw`',
            onSelectedItem: (_, row) => {
                setActiveResource(row);
                setShowDialog('withdraw');
            }
        },
        ...(isAdminOrRM ? [
            {
                isDisabled: false,
                label: 'Soft-block',
                value: 'softblock`',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setShowDialog('soft-block');
                }
            },
            {
                isDisabled: false,
                label: 'Update proposal',
                value: 'proposal`',
                onSelectedItem: (_, row) => {
                    setActiveResource(row);
                    setProposalDefaultValues({
                        demandId: row?.demand?.id,
                        id: row?.id,
                        resourceId: row?.resourceId,
                        startDate: row?.startDate,
                        endDate: row?.endDate,
                        hoursPerWeek: row?.weeklyHours,
                        hasProposalShiftTimings: row.hasProposalShiftTimings,
                        proposalId: row?.proposalId,
                        functionCode: row?.demand?.functionCode
                    });
                    setShowDialog('update-proposal');
                }
            }] : [])
    ];
};

export const getContinuityResourceProjectDetail = (fieldName, list = []) => list.map((item) => item?.project?.[fieldName] ?? item.project?.clientOpportunity?.[fieldName]).join(', ')


export const allocationToPractitioner = (data) => {
    return data.map((item) => {        
        const { resource, demand, allocationCreatedBy, allocationsModifiedBy } = item || {}

        const allocationsShiftTimings = (item?.allocationShiftTimings || [])?.sort((a, b) => new Date(a.shiftDate) - new Date(b.shiftDate));
        const currentAllocationShiftTiming = allocationsShiftTimings?.find(shift => shift.shiftDate === moment().utcOffset(330).format('YYYY-MM-DD'));
        return {
            id: item?.id,
            practitioner: {
                ID: resource?.employeeCode,
                name: resource?.name,
                designation: resource?.designation,
                subServiceArea: resource?.subServiceArea,
                location: resource?.location,
                profileImage: resource?.profilePicture,
                resId: resource?.id
            },
            resourceId: resource?.id,
            emailID: resource?.email,
            isSelectDisabled: item?.project?.publishStatus === 'draft' || item.demand?.hasConflict || demand?.status === 'pending',
            designation: resource?.designation,
            isAudit: (item?.project?.serviceArea ?? item?.project?.quote?.primaryServiceArea)?.toLocaleLowerCase() === auditSA.label.toLocaleLowerCase(),
            function: resource?.employeeFunction,
            serviceArea: resource?.serviceArea,
            subServiceArea: resource?.subServiceArea,
            demandCode: demand?.demandCode,
                shiftStartDate: allocationsShiftTimings?.[0]?.shiftDate ? moment(allocationsShiftTimings?.[0]?.shiftDate).format('MM/DD/YYYY') : '',
                shiftEndDate: allocationsShiftTimings?.[allocationsShiftTimings?.length - 1]?.shiftDate ? moment(allocationsShiftTimings?.[allocationsShiftTimings?.length - 1]?.shiftDate).format('MM/DD/YYYY') : '',
                shiftTiming: currentAllocationShiftTiming?.shiftTiming?.shiftTiming,
                shiftCategory: currentAllocationShiftTiming?.shiftTiming?.shiftType,
            demandId: demand?.id,
            gradeCode: item.resource?.gradeCode,
            isArticle: item?.resource?.isArticle,
            demandName: demand?.designation,
            demand: { ...demand, project: item?.project },
            allocationStartDate: moment(item?.startDate).format('MM/DD/YYYY'),
            allocationEndDate: moment(item?.endDate).format('MM/DD/YYYY'),
            hoursPerWeek: item?.hoursPerWeek || '-',
            createdBy: {
                id: allocationCreatedBy?.id,
                name: allocationCreatedBy?.name,
                date: `${moment(item?.createdAt).format('MM/DD/YYYY')
                    } | ${moment(item?.createdAt).format('HH:mm')} `
            },
            modifiedBy: {
                id: allocationsModifiedBy?.id,
                name: allocationsModifiedBy?.name,
                date: `${moment(item?.updatedAt).format('MM/DD/YYYY')} | ${moment(item?.updatedAt).format('HH:mm')} `
            },
            adjustedUtilizations: item?.adjustedUtilizations,
            isContinuityResource: item?.isContinuityResource,
            continuityReason: item?.continuityReason,
            continuityReasonComment: item?.continuityReasonComment,
            include: [
                {
                    label: 'Satuday',
                    value: item?.includeSaturday
                },
                {
                    label: 'Sunday',
                    value: item?.includeSunday
                }
            ],
            isPodWorkpackage: Boolean(demand?.podWorkpackage),
            hasPendingUnallocationRequest: item?.hasPendingUnallocationRequest || false
        }
    })
}

const getShiftTiming = (shortlisted) => {
    const mapping = {
        softblock: shortlisted?.softBlockShiftTimings,
        suggestion: shortlisted?.suggestionShiftTimings,
        proposal: shortlisted?.proposalShiftTimings
    };

    const shiftMapping =  mapping[shortlisted?.tableName] || [];
    return shiftMapping?.sort((a, b) => new Date(a.shiftDate) - new Date(b.shiftDate));
}


export const shortlistedToPractitioner = (data, setActiveResource, setShowDialog, session, setProposalDefaultValues, setSuggestionDefaultValue) => {

    const isAdminOrRM = ['admin', 'resource_manager', 'guest_rm', 'resource_manager_lead'].some((role) => session.data.user.role.includes(role));
    const isAdmin = ['admin'].some((role) => session.data.user.role.includes(role));
    const isPartner = session.data.user.gradeLevel === 'partner' && !isAdminOrRM;
    const isResource = session.data.user.gradeLevel === 'resource' && !isAdminOrRM;
    const isManager = session.data.user.gradeLevel === 'manager' && !isAdminOrRM;

    return data?.map((shortlisted) => {        
        const {
            id, tableName, startDate, endDate, scheduleStartDate, scheduleEndDate, proposalStatus, suggestionStatus, createdAt, resource, extendReason, weeklyHours, proposalCreatedBy, suggestionCreatedBy, softblockCreatedBy
        } = shortlisted;
        const isProposed = tableName === 'proposal';
        const isSoftblocked = tableName === 'softblock' && 'Soft Blocked';
        const isSuggested = tableName === 'suggestion' && 'Suggested';
        const isSuggestedStatus = isSuggested && (suggestionStatus === 'approved' ? 'Interested' : 'Suggested');
        const proposalStatusData = isProposed ? proposalStatusMap[proposalStatus] : null;
        const createdBy = (isProposed && proposalCreatedBy?.resource?.name)
            || (isSoftblocked && softblockCreatedBy?.resource?.name)
            || (isSuggested && suggestionCreatedBy?.resource?.name);
        const roles = session.data.user.role || [];
        const shiftTimings = getShiftTiming(shortlisted);
        const currentShiftTiming = shiftTimings?.find(shift => shift.shiftDate === moment().utcOffset(330).format('YYYY-MM-DD'));
        return {
            id,
            roles,
            demandId: shortlisted?.demandId,
            demandCode: shortlisted?.demand?.demandCode,
            demandName: shortlisted?.demand?.designation,
            sapProjectId: shortlisted?.demand?.sapProjectId,
            suggestionId: isSuggested ? id : null,
            softblockId: isSoftblocked ? id : null,
            proposalId: isProposed ? id : null,
            isPartner,
            isAdminOrRM,
            isManager,
            resourceId: resource.id,
            startDate,
            shiftStartDate: shiftTimings?.[0]?.shiftDate ? moment(shiftTimings?.[0]?.shiftDate).format('MM/DD/YYYY') : '',
            shiftEndDate: shiftTimings?.[shiftTimings.length - 1]?.shiftDate ? moment(shiftTimings?.[shiftTimings.length - 1]?.shiftDate).format('MM/DD/YYYY') : '',
            shiftTiming: currentShiftTiming?.shiftTiming?.shiftTiming,
            shiftCategory: currentShiftTiming?.shiftTiming?.shiftType,
            endDate,
            extendReason,
            defaultValues: {
                startDate: moment(scheduleStartDate).format('MM/DD/YYYY'),
                endDate: moment(scheduleEndDate).format('MM/DD/YYYY')
            },
            scheduleStartDate,
            scheduleEndDate,
            weeklyHours: AllocationHourRevereseWrapper(scheduleStartDate || startDate, scheduleEndDate || endDate, weeklyHours, false, false),
            userpic: resource?.profilePicture,
            name: resource.name,
            email: resource.email,
            manager: resource.designation,
            location: resource.location,
            function: resource?.employeeFunction,
            serviceArea: resource?.serviceArea,
            Subservice: resource.subServiceArea,
            employmentType: resource?.employmentType,
            Shortlistedon: moment(createdAt).format('MM/DD/YYYY'),
            Shortlistedby: createdBy,
            demand: {
                id: shortlisted?.demand?.id,
                demandEndDate: moment(shortlisted?.demand?.endDate).format('MM/DD/YYYY'),
                demandName: shortlisted?.demand?.designation,
                demandStartDate: moment(shortlisted?.demand?.startDate).format('MM/DD/YYYY'),
                weeklyHours: shortlisted?.demand?.noOfHoursPerWeek,
                adjustedUtilizations: shortlisted?.demand?.adjustedUtilizations,
                project: shortlisted?.demand?.projects,
                hasDemandShiftTimings: shortlisted?.demand?.hasDemandShiftTimings,
                functionCode: shortlisted?.demand?.functionCode,
                employeeType: shortlisted?.demand?.employeeType
            },
            hasProposalShiftTimings: shortlisted?.hasProposalShiftTimings,
            hasSoftBlockShiftTimings: shortlisted?.hasSoftBlockShiftTimings, 
            hasSuggestionShiftTimings: shortlisted?.hasSuggestionShiftTimings,
            demandDetailsData: {
                id: shortlisted?.demand?.id,
                hasDemandShiftTimings: shortlisted?.demand?.hasDemandShiftTimings,
                originalValue: {
                    status: shortlisted?.demand?.status,
                    conflicts: shortlisted?.demand?.conflicts
                },
                serviceArea: shortlisted?.demand?.serviceArea,
                function: shortlisted?.demand?.functionL1,
                functionCode: shortlisted?.demand?.functionCode,
                taskDescription: shortlisted?.demand?.taskDescription,
                taskCode: shortlisted?.demand?.taskCode,
                project: {
                    linkedWbsL4Codes: shortlisted?.demand?.projects?.linkedWbsL4Codes || null,
                    linkedWbsL4Count: shortlisted?.demand?.projects?.linkedWbsL4Count || 0,
                    engagementCode: shortlisted?.demand?.sapProject?.engagementCode,
                    opportunityId: shortlisted?.demand?.projects?.clientOpportunity?.opportunityId,
                    id: shortlisted?.demand?.projects?.id,
                    isSpecialProject: shortlisted?.demand?.projects?.isSpecialProject
                },
                wbsCode: shortlisted?.demand?.swiftWbsCode?.billable_l4_wbs_code || null
            },
            status: proposalStatusData || isSuggestedStatus || isSoftblocked,
            action: '',
            relievingDate: resource?.actualRelievingDate ? moment(resource?.actualRelievingDate).format(
                'MM/DD/YYYY'
            ) : null,
            derivedActions: derivedTableActions(isProposed, isSoftblocked, isSuggested, suggestionStatus, roles, proposalStatus, setActiveResource, setShowDialog, session, setProposalDefaultValues, setSuggestionDefaultValue),
            detailsData: {
                name: resource.name,
                ID: resource.employeeCode,
                position: resource.role,
                designation: resource.designation,
                category: 'AWS',
                location: resource.location,
                gradeCode: resource?.gradeCode
            },
            gradeCode: resource?.gradeCode,
            isContinuityResource: resource?.continuityResourceAllocations?.length > 0,
            continuityResourceProjectNames: getContinuityResourceProjectDetail('projectName', resource?.continuityResourceAllocations),
            continuityResourceClientNames: getContinuityResourceProjectDetail('clientName', resource?.continuityResourceAllocations),
        };
    })
};

export const rejectedToPractitioner = (rejectData) => {
     return rejectData?.flatMap((resource) => {
        const results = [];

        const buildResult = (type, data) => {
            const demand = data?.demand;

            return {
                id: resource?.id,
                resourceId: resource?.id,
                ID: resource?.employeeCode,
                position: resource?.role,
                category: 'AWS',
                userpic: resource?.profilePicture,

                demandId: demand?.id,
                demandName: demand?.designation,
                demandCode: demand?.demandCode,
                sapProjectId: demand?.sapProjectId,

                name: resource?.name,
                email: resource?.email,
                designation: resource?.designation,
                role: resource?.role,
                location: resource?.location,
                function: resource?.employeeFunction,
                serviceArea: resource?.serviceArea,
                subservicearea: resource?.subServiceArea,
                employmentType: resource?.employmentType,

                rejectedon: moment(data?.rejectedOn || new Date()).format('MM/DD/YYYY'),
                rejectedby: data?.rejectBy?.name,
                reason: data?.rejectionComment,
                additionalcomment: data?.otherComments || '-',

                proposalId: type === 'Proposed' ? data?.id : null,
                suggestionId: type === 'Suggested' ? data?.id : null,
                rejectionType: type,

                demand: {
                    demandStartDate: demand?.startDate
                        ? moment(demand.startDate).format('MM/DD/YYYY')
                        : null,
                    demandEndDate: demand?.endDate
                        ? moment(demand.endDate).format('MM/DD/YYYY')
                        : null,
                    weeklyHours: demand?.noOfHoursPerWeek,
                    demandName: demand?.designation,
                    employeeType: demand?.employeeType
                },

                demandDetailsData: {
                    id: demand?.id,
                    hasDemandShiftTimings: demand?.hasDemandShiftTimings,
                    originalValue: {
                        status: demand?.status,
                        conflicts: demand?.conflicts
                    },
                    serviceArea: demand?.serviceArea,
                    function: demand?.functionL1,
                    functionCode: demand?.functionCode,
                    taskCode: demand?.taskCode,
                    taskDescription: demand?.taskDescription,
                    project: {
                        isSpecialProject: demand?.project?.isSpecialProject
                    }
                },
                project: {
                    linkedWbsL4Codes: demand?.project?.linkedWbsL4Codes || null,
                    linkedWbsL4Count: demand?.project?.linkedWbsL4Count || 0,
                    engagementCode: demand?.sapProject?.engagementCode,
                    opportunityId: demand?.project?.clientOpportunity?.opportunityId,
                    id: demand?.projectId
                },
                wbsCode: demand?.swiftWbsCode?.billable_l4_wbs_code || null,
                gradeCode: resource?.gradeCode,
                isContinuityResource: resource?.continuityResourceAllocations?.length > 0,
                continuityResourceProjectNames: getContinuityResourceProjectDetail(
                    'projectName',
                    resource?.continuityResourceAllocations
                ),
                continuityResourceClientNames: getContinuityResourceProjectDetail(
                    'clientName',
                    resource?.continuityResourceAllocations
                )
            };
        };

        if (resource?.proposals?.length > 0) {
            results.push(buildResult('Proposed', resource.proposals[0]));
        }

        if (resource?.suggestions?.length > 0) {
            results.push(buildResult('Suggested', resource.suggestions[0]));
        }

        return results;
    });
}